const getAdditionalSessionValue = () =>
  JSON.parse(sessionStorage.getItem('additionalFeaturesData')) || {};
export default getAdditionalSessionValue;
